import React from "react"
import SEO from "../components/seo"
import Layout from "../components/layout/layout"
import PageTitle from "../components/page-title"
import { Container, Row } from "reactstrap"
import Sides from "../components/menu/full-menu/sides"
import Sausages from "../components/menu/full-menu/sausages"
import SANDWICHES from "../components/menu/full-menu/sandwiches"
import MakeCombo from "../components/menu/full-menu/make-combo"
import APPETIZERS from "../components/menu/full-menu/appetizers"
import HOTWINGS from "../components/menu/full-menu/hot-wings"
import ENTRESS from "../components/menu/full-menu/entress"
import BEVERAGES from "../components/menu/full-menu/beverages"
import ALACARTE from "../components/menu/full-menu/alacarte"
import BBQMEALS from "../components/menu/full-menu/bbqmeals"
import BURGER from "../components/menu/full-menu/burger"
import DESSERT from "../components/menu/full-menu/dessert"
import EXTRAS from "../components/menu/full-menu/extras"
import CHUCKWAGON from "../components/menu/full-menu/chuck-wagon"
import GOODCHOICE from "../components/menu/full-menu/good-choice"
import BOBSWORLD from "../components/menu/full-menu/bobs-world"
import SALADS from "../components/menu/full-menu/salads"
import MenuPdf from "../pdf/Ribs-Usa-Menu.pdf"

const FullMenu = () => {
  return (
    <Layout>
      <SEO
        title="Full Menu"
        keywords="ribsusabbq, ribs usa, ribs usa bbq, ribs, usa, bbq, best bbq near me, baby back ribs, beef ribs near me, best beef ribs near me, bbq chicken near me"
      />
      <PageTitle title="Full Menu" />
      <section id="list-menu">
        <Container>
          <Row className="up-menu">
            <div className="col-12 col-sm-12">
              <div className="text-center">
                <a
                  className="btn my-button"
                  rel="noopener noreferrer"
                  target="_blank"
                  href={MenuPdf}
                  download
                >
                  <span className="myover">Download Our Menu</span>
                </a>
              </div>
            </div>
          </Row>
          <Row>
            <div className="item-show col-md-6 col-sm-12">
              <APPETIZERS />
              <Sides />
              <BURGER />
              <Sausages />
              <SANDWICHES />
              <GOODCHOICE /> 
              <CHUCKWAGON />
              <BOBSWORLD />
              <MakeCombo />
              <DESSERT />
              <EXTRAS />
              <SALADS />
            </div>
            <div className="item-show col-md-6 col-sm-12">
              <BBQMEALS />
              <HOTWINGS />
              <ENTRESS />
              <BEVERAGES />
              <ALACARTE />
            </div>
          </Row>
        </Container>
      </section>
    </Layout>
  )
}

export default FullMenu
